import { CmsVendor } from "@modules/graphql/types"
import gql from "graphql-tag"
import { useMutation } from "react-apollo"

export const REMOVE_CMS_INTEGRATION_MUTATION = gql`
  mutation removeCmsConfigurationForSite($siteId: UUID!, $vendor: CmsVendor) {
    removeCmsConfigurationForSite(siteId: $siteId, vendor: $vendor) {
      success
      message
    }
  }
`

export const useRemoveCmsIntegration = (siteId: string, vendor: CmsVendor) => {
  const [deleteCmsIntegration] = useMutation(REMOVE_CMS_INTEGRATION_MUTATION, {
    refetchQueries: ["cmsIntegrationsForSite"],
  })

  return () =>
    deleteCmsIntegration({
      variables: {
        siteId,
        vendor: vendor.toUpperCase(),
      },
    })
}
